export default __webpack_public_path__ + "static/media/IMG-20210326-WA0040.7caed511.jpg";